<template>
  <div>
    <menberMenu :tit-names="titNames" :tit-urls="titUrls"></menberMenu>
    <div style="margin-top: 15px;" v-show="!isLoading">
      <div class="listContent">
        <div class="chkListTop">
          <p>
            <b v-if="[1,2].includes(List.OrderServiceType)">{{List.StartCityNameEn}},{{List.StartProNameEn}},{{List.StartCountryNameEn}}</b>
            <b v-if="[3,4].includes(List.OrderServiceType)">{{List.DepartureCode}},{{List.DepartureNameEn}}</b>
            <i class="fa fa-arrowEdit"></i>
            <b v-if="[1,4].includes(List.OrderServiceType)">{{List.DestAddressDesc.split(',').splice(0,List.DestAddressDesc.split(',').length-1).join('')}}</b>
            <b v-if="[2,3].includes(List.OrderServiceType)">{{List.DestinationCode}},{{List.DestinationNameEn}}</b>
          </p>
          <ul>
            <li>Commodity：{{CargoNameEn}}</li>
            <li>
              <label class="text2 total">
                <span>Shipment total: </span>
                <em>{{List.PackageQuanlity}} Unit</em>
                <em>{{InterceptUnit(List.Weight,3)}} KG</em>
                <em>{{InterceptUnit(List.VolumeCBM,4)}} CBM</em>
              </label>
            </li>
            <li>Cargo ready：{{List.PlanDeliveryTime | dateFmt('MMM DD, YYYY')}}</li>
          </ul>
        </div>
      </div>
      <table border="0" cellspacing="0" cellpadding="0" class="fff channelList" width="100%" v-for="(item,index) in channelList" :key="index">
        <tr style="border-bottom: 1px solid #dfdfdf">
          <td width="10%" align="center" class="pad10" style="border-right: 1px solid #dfdfdf">
            <p><span class="fa fa-AirWarehouse colBlue" style="font-size:30px"></span> </p>
            <p><b>{{item.AirWareShortCode}}</b></p>
          </td>
          <td width="75%" align="left" class="pad10 clear">
            <p><b class="colBrack">{{item.AirCompanyNameEn+' '+item.AirCompanyCode2+'-'+item.AirCompanyCode3}}</b><b class="r colBrack">{{item.AirArrivalType == 1 ?'Direct':'Transit'}}</b></p>
            <div class="clear">
              <p class="l colGray6" style="line-height:30px;min-width:160px">Transit time: {{item.ValidTerm}}Days</p>
              <p class=" l colGray6" style="line-height:30px;">Route: {{item.FlightCourse}}</p>
              <p class=" l colGray6" style="line-height:30px;;margin-left:20px">Frequency: {{item.Flight}}</p>
            </div>
            <p class="cl colGray6" style="line-height:20px;">
              <span class="l">Valid until: {{new Date(item.AirValidEndTime) | dateFmt('MMM DD, YYYY')}}</span>
            </p>
          </td>
          <td align="center" class="pad10" style="border-left: 1px solid #dfdfdf">
            <p>
              <b class="colRed font14">US ${{Number(item.TotalFee).toFixed(2)}}</b>
            </p>
            <p>
              <a v-if="!HiddenOrderBtn" class="blueBtnW marTop5" @click="AirOrderEn">SELECT</a>
            </p>
          </td>
        </tr>
        <tr class="feeList font12">
          <td colspan="3">
            <div class="title">
              <h3 v-if="List.OrderServiceType == 1">{{List.StartCityNameEn}} > {{List.DestinationCode}}</h3>
              <h3 v-if="List.OrderServiceType == 2">{{List.StartCityNameEn}} > {{List.DestinationCode}}</h3>
              <h3 v-if="List.OrderServiceType == 3">{{List.DepartureCode}} > {{List.DestinationCode}}</h3>
              <h3 v-if="List.OrderServiceType == 4">{{List.DepartureCode}} > {{List.DestinationCode}}</h3>
            </div>
            <table border="0" cellspacing="0" cellpadding="0" class="channel" width="100%">
              <tr>
                <th width="40%" align="left">Cost items</th>
                <th width="18%" align="left">Unit rate</th>
                <th width="17%" align="left">QTY</th>
                <th align="right">Amount</th>
              </tr>
              <tr v-show="item.THAmount">
                <td width="40%" align="left">
                  <p>Pickup Charge</p>
                </td>
                <td width="17%" align="left"> US ${{item.THAmount.toFixed(2)}}/Bill</td>
                <td width="18%" align="left">1 Shipment</td>
                <td align="right">
                  <p class="colRed"><b> US ${{item.THAmount.toFixed(2)}}</b></p>
                </td>
                <!-- <td width="17%" align="left"> US ${{(item.THAmount / item.THChargeWeight).toFixed(2)}}/KG</td>
                <td width="18%" align="left">{{item.THChargeWeight.toFixed(2) }}KG</td>
                <td align="right">
                  <p class="colRed"><b> US ${{item.THAmount.toFixed(2)}}</b></p>
                </td> -->
              </tr>
              <tr>
                <td width="40%" align="left">
                  <p>Air Freight Cost</p>
                </td>
                <td width="17%" align="left"> US ${{(item.AirPrice).toFixed(2)}}/KG</td>
                <td width="18%" align="left">{{item.AirChargeWeight.toFixed(2)}}KG</td>
                <td align="right">
                  <p class="colRed"><b> US ${{item.AirTracficFee.toFixed(2)}}</b></p>
                </td>
              </tr>
              <tr v-for="(item,index) in item.LstAirFee" :key="index">
                <td width="40%" align="left">
                  <p>{{item.FeeNameEn}}</p>
                </td>
                <td width="17%" align="left"> US ${{(item.Amount/item.Quanlity).toFixed(2) }}/{{getUnit(item.Unit,true)}}</td>
                <td v-if="item.Unit == 1 || item.Unit == 3" width="18%" align="left">{{item.Quanlity.toFixed(2)}}{{getUnit(item.Unit)}}</td>
                <td v-if="item.Unit != 1 && item.Unit != 3" width="18%" align="left">{{item.Quanlity}}{{getUnit(item.Unit)}}</td>
                <td align="right">
                  <p class="colRed"><b>US ${{item.Amount.toFixed(2)}}</b></p>
                  <p class="spcText" v-if="item.MaxValue != null && item.MinValue != null">
                    (
                    <span v-if="item.MaxValue != null">Max US ${{Number(item.MaxValue).toFixed(2)}}</span>
                    <span v-if="item.MinValue != null">,Min US ${{Number(item.MinValue).toFixed(2)}}</span>)
                  </p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="feeList font12">
          <td colspan="3" v-if="!(List.OrderServiceType== 2 || List.OrderServiceType== 3)">
            <div class="title">
              <h3 v-if="List.OrderServiceType == 1">{{List.DepartureCode}} > {{List.DestAddressDesc.split(',').splice(0,List.DestAddressDesc.split(',').length-1).join('')}}</h3>
              <h3 v-if="List.OrderServiceType == 4">{{List.DepartureCode}} > {{ List.DestAddressDesc.split(',').splice(0,List.DestAddressDesc.split(',').length-1).join('')}}</h3>
            </div>
            <table border="0" cellspacing="0" cellpadding="0" class="channel" width="100%">
              <tr>
                <th width="40%" align="left">Cost items</th>
                <th width="18%" align="left">Unit rate</th>
                <th width="17%" align="left">QTY</th>
                <th align="right">Amount</th>
              </tr>
              <tr v-show="List.IsBond">
                <td width="40%" align="left">
                  <p>Bond</p>
                </td>
                <td width="18%" align="left"></td>
                <td width="17%" align="left"></td>
                <td align="right">
                  <p class="colRed"><b> US ${{item.BondAmount.toFixed(2)}}</b></p>
                </td>
              </tr>
              <tr v-for="(item,index) in item.LstDestFee" :key="index">
                <td width="40%" align="left">
                  <p>{{item.FeeNameEn}}</p>
                </td>
                <td width="17%" align="left"> US ${{(item.Amount/item.Quanlity).toFixed(2)}}/{{getUnit(item.Unit,true)}}</td>
                <td v-if="item.Unit == 1 || item.Unit == 3" width="18%" align="left">{{item.Quanlity.toFixed(2)}}{{getUnit(item.Unit)}}</td>
                <td v-if="item.Unit != 1 && item.Unit != 3" width="18%" align="left">{{item.Quanlity}}{{getUnit(item.Unit)}}</td>
                <td align="right">
                  <p class="colRed"><b>US ${{item.Amount.toFixed(2)}}</b></p>
                  <p class="spcText" v-if="item.MaxValue != null && item.MinValue != null">
                    (
                    <span v-if="item.MaxValue != null">Max US ${{Number(item.MaxValue).toFixed(2)}}</span>
                    <span v-if="item.MinValue != null">,Min US ${{Number(item.MinValue).toFixed(2)}}</span>)
                  </p>
                </td>
              </tr>
              <tr v-show="item.DeliverAmount" style="border-bottom: 1px dashed #E2E2E2;">
                <td width="40%" align="left">
                  <p>Delivery Charge</p>
                </td>
                <td width="17%" align="left"> US ${{item.DeliverPrice.toFixed(2) }}/KG</td>
                <td width="18%" align="left">{{item.DeliverChargeWeight.toFixed(2) }}KG</td>
                <td align="right">
                  <p class="colRed"><b> US ${{item.DeliverAmount.toFixed(2)}}</b></p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="feeList channelTr dashedLine " v-if="!isWCA">
          <td colspan="2" align="left" class="padLR10">Bank Charge:</td>
          <td align="right" class="padLR10 colRed bold">US ${{item.BankChargeAmount.toFixed(2)}}</td>
        </tr>
        <tr class="feeList channelTr " style="font-size:16px">
          <td colspan="3" align="right" class="padLR10  bold ">
            <label class="hint">
              <i class="fa fa-tips colRed  marR5" style="margin-top:-4px;"></i>
              <div class="floTipBox" style="width:220px;left:-30px;top:30px">
                <i style="right:55px;"></i>
                <p class="font12" style="color:#4a4a4a">If your actual shipment is different from the information provided, you may incur additional fees.</p>
              </div>
            </label>
            <span>Total：</span><span class="colRed">US ${{item.TotalFee.toFixed(2)}}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="listDataNone" v-show="isLoading ">
      <div class="textNone">
        <p class="padTop10">
          <img src="@/assets/img/loading.gif" style="width:50px;height:50px;">
        </p>
        <p style="padding-top:5px;"></p>
      </div>
    </div>
  </div>
</template>
<script>
import menberMenu from '@/components/userCenter/public/menberPageMenu.vue'
import { post, fetch, Del, put } from '@/ask/axios'
export default {
  components: { menberMenu },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },
      titNames: 'Saved Quotes',
      titUrls: '',
      isLoading: true,
      List: [],
      channelList: [],
      HiddenOrderBtn: false,
      typeGoodsItem: [],
      CargoNameCn: [],
      CargoNameEn: [],
      CargoIDs: [],
      CargoTypeIDs: [],
      isWCA: false,
    }
  },
  created() {
    this.WCA()
    this.waitInfo()
  },
  mounted() {
  },
  methods: {
    CustomerInfo() {
      // this.api.url=this.$api02+"/api/EbayCustomer/CustomerInfo/GetCustomerInfoByToken";
      this.api.url = this.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByToken";
      this.api.param = {
      }
      return new Promise((resolve, reject) => {
        post(this.api.url, this.api.param).then(response => {
          let a = response;
          resolve(a);
        });
      });
    },
    // 获取用户具体信息
    GetCustomerInfoByID(CustomerID) {
      // this.api.url=this.$api02+"/api/EbayCustomer/CustomerInfo/GetCustomerInfoByID";
      // this.api.param = {
      //   id:CustomerID
      //   }
      this.api.url = this.$api04 + "/Basics/api/CustomerInfo/GetCustomerInfoByID";
      this.api.param = {
        // id: CustomerID
        CustomerID: CustomerID
      }
      return new Promise((resolve, reject) => {
        fetch(this.api.url, this.api.param).then(response => {
          let a = response;
          resolve(a);
        });
      });
    },
    async WCA() {
      let getId = await this.CustomerInfo()
      let CustomerID = getId.Results.CustomerID
      let CustomerInfo = await this.GetCustomerInfoByID(CustomerID)
      let isWCA = CustomerInfo.Results.IsWCA
      if (isWCA) {
        this.isWCA = true
      } else {
        this.isWCA = false
      }
    },
    getTypeCargo() {
      this.api.param = {
        AttrMain_Code: "KYSHSpecial"
      };
      // this.api.url = this.$api01 + "/api/Attribute/QueryList";
      this.api.url = this.$api04 + "/Basics/api/Attribute/QueryList";
      return new Promise((resolve, reject) => {
        post(this.api.url, this.api.param).then((res) => {
          let a = res.Results[0].valList;
          a.forEach(item => {
              this.$set(item, 'Id', item.AttrVal_ID);
            })
          resolve(a);
        });
      });
    },
    async waitInfo() {
      this.List = await this.getAirPriceStore()
      this.ScreenQuery(this.List)
      this.typeGoodsItem = await this.getTypeCargo()
      this.getradCargoInfo()
    },
    getradCargoInfo() {
      //console.log(this.List.CargoIDs)
      this.CargoTypeIDs = this.List.CargoIDs.split(',')
      this.CargoNameCn = []
      this.CargoNameEn = []
      //确保CargoTypeIDs是int型。不然走不进去
      this.CargoTypeIDs = this.CargoTypeIDs.map(item => {
        return +item;
      });
      for (let index = 0; index < this.typeGoodsItem.length; index++) {
        if (this.CargoTypeIDs.includes(this.typeGoodsItem[index].Id)) {
          this.CargoNameCn.push(this.typeGoodsItem[index].AttrVal_Content)
          this.CargoNameEn.push(this.typeGoodsItem[index].AttrVal_ContentEn)
        }
      }
      this.CargoNameCn = this.CargoNameCn.join()
      this.CargoNameEn = this.CargoNameEn.join()
      this.CargoIDs = this.CargoTypeIDs.join()
    },
    getAirPriceStore() {
      let skip = this.$route.query.id
      this.api.param = {
        storeType: 1,
        skip: skip,
        take: 1,
        //类型 1:空运门到门 2：海运
      }
      this.api.url = this.$api04 + "/Air/api/AirQueryPriceStore/GetAirQueryPriceStore";
      return new Promise((resolve, reject) => {
        post(this.api.url, this.api.param).then((res) => {
          if (res.IsOK) {
            resolve(res.Results[0])
          }
        })
      })
    },
    ScreenQuery(data) {
      let LstStartAirPortCode3 = data.DepartureCode ? [data.DepartureCode] : []
      let LstDestAirPortCode3 = data.DestinationCode ? [data.DestinationCode] : []
      //console.log(LstStartAirPortCode3,LstDestAirPortCode3)
      let GoodsReadyTime = ''
      let CurTime = new Date(new Date().toLocaleDateString()).getTime();
      if (new Date(this.List.PlanDeliveryTime).getTime() < CurTime) {
        GoodsReadyTime = new Date()
        this.HiddenOrderBtn = true
      } else {
        GoodsReadyTime = this.List.PlanDeliveryTime
      }
      let ArrivalType = 1
      if (data.TransferAirPort) {
        ArrivalType = 2
      }
      this.api.param = {
        "OrderServiceType": data.OrderServiceType,
        "QueryGoodType": data.QueryGoodType,
        "ChannelOwnerType": 0,
        "StartCityKey": data.StartCityKey,
        "DestCountryKey": data.DestCountryKey,
        "LstStartAirPortCode3": LstStartAirPortCode3,
        "LstDestAirPortCode3": LstDestAirPortCode3,
        "AirCompanyKey": data.AirCompanyKey,
        "TotalQuanlity": data.PackageQuanlity,
        "TotalWeight": data.Weight,
        "TotalCBM": data.VolumeCBM,
        "GoodInfos": [],
        "ArrivalType": ArrivalType,
        "TransferAirport": data.TransferAirPort,
        "CargoTypeIDs": data.CargoIDs.split(','),
        "GoodsReadyTime": data.PlanDeliveryTime,
        "IsDestCustoms": data.IsDestCustoms,
        "IsBond": data.IsBond,
        "BondType": data.BondType,
        "BondValue": data.BondValue,
        "CustomerID": data.CustomerID,
        "AirChannelKey": data.ChannelKey,
        "IsSHReport": data.IsSHReport,
        "IsQueryDisableAirChannel": false,
        "QueryGoodType": 2,
        "Destination": data.DestAddressDesc,
        "LstDestinationTerms": [],
        "platformType": "web",
        "isLogin": true,
        "entrance": "Air Freight"
      }
      this.api.url = this.$api01 + "/api/InfoCustomer/AirCalculation/QueryPriceEn";
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK == true) {
          this.isLoading = false
          this.channelList = res.Results.List
        }
      })
    },
    getUnit(unit, hasBill) {
      // 计费单位 目的地费用:（0：票，1：CBM，2：份，3：KG,4：页，5：单,6：天，7：次，8：件）
      switch (unit) {
        case 0:
          if (hasBill) {
            return 'Bill'
          }
          return 'B\\L'
        case 1:
          return 'CBM'
        case 2:
          return 'Pcs'
        case 3:
          return 'KG'
        case 4:
          return 'Page'
        case 5:
          if (hasBill) {
            return 'Bill'
          }
          return 'B\\L'
        case 6:
          return 'Day'
        case 7:
          return 'Time'
        case 8:
          return 'Unit'
      }
    },
    // 下单接口
    AirOrderEn() {
      this.getradCargoInfo()
      let curList = this.channelList[0]
      this.api.param = {
        "Order": {
          "AirChannelKey": curList.AirChannelKey,
          "AirCompanyKey": curList.AirCompanyKey,
          "AirCompanyCode": curList.AirCompanyCode2,
          "AirCompanyName": curList.AirCompanyName,
          "DepartureCode": curList.StartAirPortCode3,
          "DepartureName": curList.StartAirportName,
          "DestinationCode": curList.DestAirPortCode3,
          "DestinationName": curList.DestAirportName,
          "FlightInfo": curList.Flight,
          "ValidTerm": curList.ValidTerm,
          "AirArrivalType": curList.AirArrivalType,
          "OrderPrice": curList.AirPrice,
          "OrderAmount": curList.TotalFee,
          "OrderTrafficAmount": curList.AirTracficFee,
          "OrderWeight": curList.AirChargeWeight,
          "PackageUnit": 1,
          "SecondFlight": curList.SecondFlight,
          "TransferAirport": curList.TransferAirportCode3,
          "AirChannelName": curList.AirChannelName,
          "DepartureNameEn": curList.StartAirportNameEn,
          "DestinationNameEn": curList.DestAirportNameEn,
          "AirCompanyCode3": curList.AirCompanyCode3,
          "QueryGoodUnit": 0,
          "Weight": this.List.Weight,
          "PackageQuanlity": Number(this.List.PackageQuanlity),
          "VolumeCBM": Number(this.List.VolumeCBM),
          "PlanDeliveryTime": this.List.GoodsReadyTime,
          "OrderServiceType": this.List.OrderServiceType,
          "QueryGoodType": 2,
          "CargoIDs": this.CargoIDs,
          "CargoNameCn": this.CargoNameCn,
          "CargoNameEn": this.CargoNameEn,
        },
        "OrderExt": {
          "StartCountryKey": this.List.StartCountryKey,
          "StartCountryNameCn": this.List.StartCountryNameCn,
          "StartCountryNameEn": this.List.StartCountryNameEn,
          "StartProKey": this.List.StartProKey,
          "StartProNameCn": this.List.StartProNameCn,
          "StartProNameEn": this.List.StartProNameEn,
          "StartCityKey": this.List.StartCityKey,
          "StartCityNameCn": this.List.StartCityNameCn,
          "StartCityNameEn": this.List.StartCityNameEn,
          "DestCountryKey": this.List.DestCountryKey,
          "DestCountryNameCn": this.List.DestCountryNameCn,
          "DestCountryNameEn": this.List.DestCountryNameEn,
          "DestProKey": this.List.DestProKey,
          "DestProNameCn": this.List.DestProNameCn,
          "DestProNameEn": this.List.DestProNameEn,
          "DestCityKey": this.List.DestCityKey,
          "DestCityNameCn": this.List.DestCityNameCn,
          "DestCityNameEn": this.List.DestCityNameEn,
          "DestSvcID": curList.DestSvcID,
          "THChannelKey": curList.THChannelKey,
          "IsStartCustoms": null, //其运地没有
          "IsDestCustoms": this.List.IsDestCustoms,
          "IsBond": this.List.IsBond,
          "BondType": this.List.BondType,
          "BondValue": this.List.BondValue,
          "DestSvcID": curList.DestSvcID,
          "DestAddressDesc": this.List.DestAddressDesc,
        },
        "GoodVolumeList": this.List.GoodInfos,
        "DeliverOrder": {
          "DestSvcID": curList.DestSvcID
        },
        "FeeItem": curList.LstAirFee.concat(curList.LstDestFee),
      },
        this.api.url = this.$api03 + "/api/TradeCustomer/AirOrderEn/AddConfirmOrder";
      post(this.api.url, this.api.param).then((res) => {
        if (res.IsOK) {
          this.$router.push({
            path: "/air/airEdit",
            query: {
              "ord": res.Results.WaybillNO
            }
          });
          // window.open(routeUrl.href, '_blank');
        }
      })
    },
  },
}
</script>
<style>
@import "../../../assets/css/tipsMessage.css";
.checkAirList .el-radio__label {
  font-size: 12px !important;
}
.checkAirList .el-checkbox__input.is-checked + .el-checkbox__label {
  color: black !important;
}
.checkAirList .el-radio__input.is-checked + .el-radio__label {
  font-weight: bold;
  color: black;
}
.unit_select .el-input__inner {
  border: none !important;
  background: #f7f7f7 !important;
  padding-left: 6px !important;
  font-size: 12px !important;
}
.unit_select .el-input__suffix {
  right: 0 !important;
}
.Recent {
  background: #f5f5f5;
}
</style>
<style scoped>
@import "../../../assets/css/userCenterCss.css";
@import "../../../assets/css/frame.css";
.total {
  float: right !important;
  text-align: right;
  line-height: 20px;
  width: auto !important;
}
.GoodsCheck .chkContent {
  padding: 9px 0 0 57px;
}
.listContent .chkOneCon .checkInput li {
  padding: 0 !important;
}
.icon_title {
  font-size: 12px;
  font-weight: bold;
  margin: 0 34px 0 20px;
  font-size: 12px;
}
.Square {
  height: 40px;
  width: 40px;
  background: #0b2137;
  display: inline-block;
  color: white;
  text-align: center;
  line-height: 40px;
  border-radius: 10px 0 0 0;
}
.checkTitle {
  padding: 0 !important;
}
.chkTwoCon .chkTwoUl li {
  padding: 0 !important;
}
.ccl {
  border-top: 1px solid #f4f4f4;
  padding-top: 18px;
  padding-left: 57px;
  padding-bottom: 10px;
}
.font12 {
  font-size: 12px !important;
}
.lineInput {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 5px;
}
.goodInfo {
  padding: 20px 0 10px 54px;
}
.aircheckList {
  width: 100%;
  height: 100%;
}
.aircheckList .dataLeft {
  float: left;
  width: 18.5%;
  height: 100%;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 1.5%;
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.aircheckList .dataLeft h4 {
  font-size: 12px;
  background-color: #f8f8f8;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
}
.aircheckList .dataLeft h4 a {
  color: #004fb1;
  float: right;
}
.aircheckList .chkMode {
  padding: 10px 20px;
}
.aircheckList .dataLeft label {
  display: block;
  line-height: 30px;
  margin-right: 0px !important;
  width: 80%;
}
.aircheckList .chkMode a {
  color: #004fb1;
  font-size: 12px;
  float: right;
}
.aircheckList .dataRight {
  float: right;
  width: 80%;
}
.cksort {
  font-size: 13px !important;
  line-height: 14px;
  color: black;
}
.CheckAirTable2 {
  background: #fff;
  width: 100%;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.CheckAirTable2 tr th {
  padding: 10px;
  border-bottom: 1px solid #eee;
}
.CheckAirTable2 tr td {
  border-right: 0px;
  padding: 8px 10px;
} /* border-bottom:1px dashed #eee; */
.CheckAirTable2 tr td p {
  font-size: 12px;
  color: #6d6d6d;
}
.CheckAirTable2 tr td p.spcText {
  font-size: 12px;
  color: #999;
  line-height: 16px;
}
.CheckAirTable2 tr.totalSet {
  font-size: 16px;
  background: #edf0f5;
  border: 0px;
}
.CheckAirTable2 tr td .MainRate {
  background: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 3px;
  padding: 15px 15px 0 15px;
  margin: 5px;
  max-height: 200px;
  overflow: auto;
}
.CheckAirTable2 tr td .MainRate p {
  color: #999;
  line-height: 22px;
  font-size: 12px;
}
.channel tr {
  height: 40px;
  border-bottom: 1px dashed #e2e2e2;
}
.channel tr td {
  padding: 8px 0;
}
.channel tr td:last-child {
  padding-right: 10px;
}
.channel tr th:last-child {
  padding-right: 10px;
}
.channel tr td:first-child {
  padding-left: 10px;
}
.channel tr th:first-child {
  padding-left: 10px;
}
.channelTr td:first-child {
  padding-left: 10px;
}
.channelTr td:last-child {
  padding-right: 10px;
}
.channelTr {
  height: 40px;
}
.feeList .title h3 {
  color: #004fb1;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  background: #f8fafc;
}
.rigMsgRed {
  min-height: 20px;
}
.pgcolor {
  color: #606266;
}
.LastBotTr {
  border-bottom: 1px solid #eee;
  background: #f8fafc;
}
/* .borColRed{border: none !important;box-shadow:0px 0px 0px 1px red;border-radius: 3px;} */

.icon_aa {
  display: block;
  float: left;
  padding-top: 7px;
}
.fa-add {
  vertical-align: top !important;
}
.blod {
  font-weight: bold;
}
.color35 {
  color: #353535;
}
.block {
  display: block;
}
.linkWhite {
  padding: 0;
  margin: 0;
  display: block;
  width: 70px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  border-radius: 15px;
  border: 1px solid #004fb1;
  background: white;
  color: #004fb1;
}
.enter_Btn {
  width: 108px;
  height: 28px;
  line-height: 28px;
  background: #004fb1;
  color: white;
}
.cancel_Btn {
  width: 108px;
  height: 28px;
  line-height: 28px;
}
.channel {
  font-size: 14px;
}
.channelList {
  margin-bottom: 10px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
</style>





// WEBPACK FOOTER //
// src/components/userCenter/myInfo/myAirPriceStoreDetail.vue